// // src/components/YouTubeVideos.tsx
// import React, { useState } from 'react'
// import CopyIcon from '../../../../components/common/icons/CopyIcon'
// // import { Button } from '../../../../components/common'
// import { useYoutubeVideos } from '../../../Home/api'

// const YouTubeVideos: React.FC = () => {
//   const { data, isLoading } = useYoutubeVideos()
//   const [copied, setCopied] = useState(false);

//   if (isLoading) {
//     return <div className="text-center py-8">Loading videos...</div>
//   }

//   if (!data) {
//     return <div className="text-center py-8">No videos found.</div>
//   }
//   console.log(data?.data)

//   return (
//     <div className="bg-[#fff6ed]">
//       <div className="py-10 lg:px-4 w-11/12 mx-auto">
//         <h2 className="text-lg font-semibold mb-6">Youtube Videos</h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {data?.data?.map((video: any) => (
//             <div key={video.id} className="bg-white shadow rounded-md">
//               <div className="w-full h-[400px]">
//                 <iframe
//                   className="w-full h-full"
//                   src={
//                     video.type === 'url'
//                       ? video.source
//                           .replace('youtube.com/', 'youtube.com/embed/')
//                           .replace('youtu.be/', 'youtube.com/embed/')
//                       : video.source
//                   }
//                   title={video?.title}
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                   allowFullScreen
//                 ></iframe>
//               </div>
//               {/* <div className="flex justify-between p-2">
//                 <div className="text-sm text-gray-900 mt-2">{video.title}</div>
//                 <button className="text-xs text-primaryBlue mt-1 hover:underline flex gap-2 items-center">
//                   Copy Link
//                   <span>
//                     <CopyIcon />
//                   </span>
//                 </button>
//               </div> */}
//               <div className="flex justify-between p-2">
//       <div className="text-sm text-gray-900 mt-2">{video.title}</div>
//       <button
//         onClick={handleCopy}
//         className="text-xs text-primaryBlue mt-1 hover:underline flex gap-2 items-center"
//       >
//         {copied ? "Copied!" : "Copy Link"}
//         <span>
//           <CopyIcon size={14} />
//         </span>
//       </button>
//     </div>
//             </div>
//           ))}
//         </div>
//         {/* <div className="flex justify-center mt-6">
//           <div className="flex justify-center mt-4">
//             <Button label="View more" className="lg:px-16 lg:min-h-12" />
//           </div>
//         </div> */}
//       </div>
//     </div>
//   )
// }

// export default YouTubeVideos
import { useState } from 'react'
import { CopyIcon } from 'lucide-react'
import { useYoutubeVideos } from '../../../Home/api'
import Navigator from '../../../../components/common/Navigator'
// import { useYoutubeVideos } from "./api" // adjust import

const YouTubeVideos: React.FC = () => {
  const { data, isLoading } = useYoutubeVideos()
  const [copiedId, setCopiedId] = useState<string | null>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const totalEvents = data?.data?.length
  const totalPages = Math.ceil(totalEvents / pageSize)
  const startIndex = (currentPage - 1) * pageSize
  const paginatedEvents = data?.data.slice(startIndex, startIndex + pageSize)

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage)
    }
  }

  const handleChangeRowsPerPage = (newSize: number) => {
    setPageSize(newSize)
    setCurrentPage(1) // reset to first page when page size changes
  }
  if (isLoading) {
    return <div className="text-center py-8">Loading videos...</div>
  }

  if (!data) {
    return <div className="text-center py-8">No videos found.</div>
  }

  const handleCopy = async (url: string, id: string) => {
    try {
      await navigator.clipboard.writeText(url) // copies link
      setCopiedId(id)
      setTimeout(() => setCopiedId(null), 2000) // reset after 2s
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 bg-white py-10 lg:my-8">
      <Navigator title="Gallery" slug="GALLERY_Photo" />
      <span className="font-barlow font-medium text-4xl leading-[40px] text-black">
        Youtube Videos
      </span>
      {/* <p className="text-gray-900 mb-4">Through the Lens</p> */}

      <hr className="border-t-2 border-primaryBlue mb-6 mt-3" />

      <div className="bg-[#fff6ed] mt-4">
        <div className="py-10 lg:px-0 w-11/12 mx-auto">
          {/* <h2 className="text-lg font-semibold mb-6">Youtube Videos</h2> */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {paginatedEvents?.map((video: any) => {
              const embedUrl =
                video.type === 'url'
                  ? video.source
                      .replace('youtube.com/', 'youtube.com/embed/')
                      .replace('youtu.be/', 'youtube.com/embed/')
                  : video.source

              return (
                <div key={video.id} className="bg-white shadow rounded-md">
                  <div className="w-full h-[400px]">
                    <iframe
                      className="w-full h-full"
                      src={embedUrl}
                      title={video?.title}
                      frameBorder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <div className="flex justify-between p-2">
                    <div className="text-sm text-gray-900 mt-2">
                      {video.title}
                    </div>
                    <button
                      onClick={() => handleCopy(video.source, video.id)}
                      className="text-xs text-primaryBlue mt-1 hover:underline flex gap-2 items-center"
                    >
                      {copiedId === video.id ? 'Copied!' : 'Copy Link'}
                      <span>
                        <CopyIcon size={14} />
                      </span>
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="flex justify-between pb-10 w-11/12 mx-auto">
          <div className="flex justify-center mt-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
            >
              <span>＜</span>
            </button>
            <button className="w-12 h-10 lg:w-16 md:w-14 flex items-center justify-center">
              <span className="p-2 border rounded">{currentPage}</span>
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
            >
              <span>＞</span>
            </button>
          </div>

          <div className="flex justify-center mt-4 mx-1">
            <select
              value={pageSize}
              onChange={(e) => handleChangeRowsPerPage(Number(e.target.value))}
              className="border p-2 rounded"
            >
              {[10, 20, 30, 50, 100, 200].map((size) => (
                <option key={size} value={size}>
                  {size} cards
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  )
}

export default YouTubeVideos
